<script lang="ts" setup>
import { ILoginData } from 'Auth';
import { IModalEmits } from 'Modal';
import FormLogin from 'Components/FormLogin/FormLogin.vue';
import { BaseModal } from 'Components/Base/BaseModal';

const emit = defineEmits<IModalEmits<ILoginData>>();

function onSuccess(loginData: ILoginData) {
  emit('success', loginData);
}

function onCancel() {
  emit('cancel');
}

function onError(error: unknown) {
  emit('error', error);
}

const props = defineProps<{
  redirectOnSignup?: string;
}>();

</script>

<template>
  <BaseModal
    class="ModalLogin modal-login"
    show
    size="small"
    @close="onCancel"
  >
    <div class="modal-login__wrapper">
      <h3 class="modal-login__title">Log In</h3>
      <FormLogin
        :redirect-on-signup="props.redirectOnSignup"
        @success="onSuccess"
        @error="onError"
      />
    </div>
  </BaseModal>
</template>

<style lang="sass" scoped>
@import '~Styles/_variables'
.modal-login
  ::-webkit-scrollbar
    display: none
    width: 0px
    background: transparent /* make scrollbar transparent */
  &__title
    text-align: center
    margin-bottom: 20px
    font-size: 20px
    line-height: 28px
  &__wrapper
    display: flex
    flex-direction: column
    max-height: 100%
    @media screen and (max-height: 609px) and (orientation: landscape)
      height: 80vh
      max-height: 609px
  :deep(.modal__container)
    background-color: $gray-10
    max-width: 410px !important
    max-height: 100%
    overflow-y: auto
</style>
